export enum __HiringTabEnum {
    features = 1,
    requirements,
    description,
    benefits,
    about,
}
